import http from 'shared/services/http';
import queryString from 'query-string';

export default class SearchService {
  static querySuppliers(query) {
    return http.get(`/suppliers/query?${query}`);
  }
}
